export default __webpack_public_path__ + "static/media/escuela_verde_actividad.06aae05f.jpeg";